import { render, staticRenderFns } from "./UploadPhotoDialog.vue?vue&type=template&id=9cdb6d8a"
import script from "./UploadPhotoDialog.vue?vue&type=script&lang=js"
export * from "./UploadPhotoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports